import { IdealistDayEvent as ApiIdealistDayEvent } from 'api/groupAdmin';
import { Volop as ApiVolop } from 'api/volopsAdmin';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action } from '../../actions/groupDashboard/listings';

export type Listing = (ApiVolop | ApiIdealistDayEvent) & {
  isFetching: boolean;
};
export type State = {
  byId: Record<string, Listing>;
};
const initialState = {
  byId: {},
};
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/default-param-last
export default function listings(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'GROUP_DASHBOARD_FETCH_LISTING_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.listingId]: {
            ...state.byId[action.listingId],
            id: action.listingId,
            isFetching: true,
          },
        },
      };

    case 'GROUP_DASHBOARD_FETCH_LISTING_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.listing.id]: { ...action.listing, isFetching: false },
        },
      };

    case 'GROUP_DASHBOARD_RESET_LISTING':
      return initialState;

    default:
      // this causes a flow error if there are any unhandled actions
      action as never; // eslint-disable-line no-unused-expressions

      return state;
  }
}
